import { action } from 'easy-peasy';
import { IActionDeleteInsurance } from '../types';

const deleteInsurance: IActionDeleteInsurance = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default deleteInsurance;
